export interface Role {
  id: string;
  name: string;
}

export interface OrgLookupType {
  orgLookupTypeId: number;
  name: string;
};

export interface User {
  id: string;
  userId: number;
  title: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  name: string;
  userName: string;
  passwordHash: string;
  securityStamp: string;
  lastLoginDate: Date;
  lastLoginAttempt: Date;
  modified: Date;
  created: Date;
  active: boolean;
  roles: Role[];
  roleEntity: string;
  locale: string;
  orgLookupTypeIds: number[];
  authProvider?: string;
  externalId?: string;
  settings?: UserSettingsModel;
}

export interface UserRole {
  userId: number;
  roleId: number;
}


export interface UserRequestModel {
  pageSize: number;
  pageNumber: number;
  orderBy?: string;
  orderAscending?: boolean;
  searchTerm?: string;
  filter?: string;
}


export interface UserResponseModel {
  page: number;
  users: User[];
  totalCount: number;
}

export interface UserByNameRequestModel {
  userName: string;
}

export interface UserByIdRequestModel {
  userId: number;
}

export interface UserSettingsModel {
  locale: string;
  theme: string;
  timeZone: string;
  rolePinned?: boolean;
}

export interface UserRequest {
  title: string;
  roleEntity: string;
  firstName: string;
  lastName: string;
  userName: string;
  active: boolean;
  authProvider: string;
  externalId: string;
  emailAddress: string;
  password?: string;

  // Settings properties
  locale: string;
  timeZone: string;
  theme: string;
  rolePinned?: boolean;

  // Foreign keys
  userRoleIds: string[];
}

